export default __webpack_public_path__ + "static/media/PayPal-logo.cf752710.svg";